import React from 'react';
import styled from 'styled-components';
import {colorTheme} from '../../../mixin/colorTheme';
import {Btn} from '../../button/btn-type/Btn';
import {Icon} from '../../Icon/Icon';
import {TableData} from '../table-sections/TableData';

export const TableBtn = ({...props}) => (
    <TableBtnContainer colSpan={999}>
        <Btn {...props} ghost color="primary" type="button">
            <Icon name="add" type="md" />
        </Btn>
    </TableBtnContainer>
);

export const TableBtnContainer = styled(TableData)`
    padding: 0;
    ${colorTheme({
        '--table-btn-color   ': {dark: 'var(--blue-13)       ', light: 'var(--blue-05)'},
        '--table-btn-color-hover   ': {dark: 'var(--blue-15)       ', light: 'var(--blue-06)'},
        '--table-btn-text-color   ': {dark: 'var(--white-00)       ', light: 'var(--primary)'},
        '--table-btn-text-color-hover   ': {dark: 'var(--blue-07)       ', light: 'var(--primary-dark)'},
        '--table-btn-shadow   ': {dark: 'var(--shadow-dark-05)       ', light: 'var(--shadow-light-06)'},
    })};
    ${Btn} {
        width: 100%;
        margin: 0;
        padding: 8px;
        background: var(--table-btn-color);
        border: none;
        color: var(--table-btn-text-color);
        box-shadow: var(--table-btn-shadow);

        &:hover {
            background: var(--table-btn-color-hover);
            color: var(--table-btn-text-color-hover);
        }
    }
`;
